import ProjectHeader from '../components/work/Header.vue'
import ProjectFooter from '../components/work/Footer.vue'
import WebsiteVideo from '../components/WebsiteVideo.vue'

export default {
  components: {
    ProjectHeader,
    ProjectFooter,
    WebsiteVideo
  }
}



// WEBPACK FOOTER //
// ./src/mixins/project.js